import {loadable} from 'router/routes';

const Developers = loadable(() => import('./Developers'));

export default Developers;
